import { transport } from 'config/transport';

export function callApiGetThuChiDauNamNhiemKy(congDoanId, academicYear, type) {
    return transport.get(`/mamnon/cong-doan/${congDoanId}/thuchidaunam-nhiemky`, { params: { academicYear, type } });
}
